import { useState } from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX } from 'lucide-react';
import { toggleMute, getMuteState } from '../lib/SoundManager';

const MusicToggle = () => {
  const [muted, setMuted] = useState(getMuteState());

  const handleToggle = () => {
    const newState = toggleMute();
    setMuted(newState);
  };

  return (
    <motion.button
      data-testid="music-toggle"
      onClick={handleToggle}
      whileTap={{ scale: 0.9 }}
      className="fixed top-3 right-3 z-50 bg-stone-900/80 backdrop-blur-md p-2.5 rounded-full border-2 border-stone-700 hover:border-amber-400 transition-colors shadow-lg"
      title={muted ? 'Unmute' : 'Mute'}
    >
      {muted ? (
        <VolumeX className="w-5 h-5 text-stone-400" />
      ) : (
        <Volume2 className="w-5 h-5 text-amber-400" />
      )}
    </motion.button>
  );
};

export default MusicToggle;
